<template>
  <form @submit.prevent="doSubmit">
    <p class="has-text-grey mb-1">{{ $t("mp:two_factor.welcome.title") }}</p>

    <template v-if="status === LOGIN_STATUS.EMAIL_NOT_CONFIRMED">
      <p class="is-size-3 has-text-weight-bold">
        {{ $t("mp:two_factor.email_confirm.title") }}
      </p>

      <div class="is-flex">
        <img
          :src="require('@/assets/images/email-confirmation.svg')"
          alt="email-confirmation"
        />
        <div class="has-text-grey ml-5 mt-2">
          <p class="has-text-weight-bold mb-0">
            {{ $t("mp:two_factor.description.title") }}
          </p>
          <p>{{ $t("mp:two_factor.description.label") }}</p>
        </div>
      </div>
    </template>

    <template v-if="successfulEmailConfirmation">
      <p class="is-size-3 has-text-weight-bold">
        {{ $t("mp:two_factor.phone_confirm.email_success.title") }}
      </p>

      <div class="is-flex mb-6">
        <img
          :src="require('@/assets/images/email-confirmed.svg')"
          alt="email-confirmed"
        />
        <div class="has-text-grey ml-5 mt-3">
          <p>
            {{ $t("mp:two_factor.phone_confirm.email_success.description") }}
          </p>
        </div>
      </div>
    </template>

    <template
      v-if="
        status === LOGIN_STATUS.LOGIN_OK ||
        status === LOGIN_STATUS.PHONE_NOT_CONFIRMED
      "
    >
      <p class="is-size-3 has-text-weight-bold mb-5">
        <span v-if="status === LOGIN_STATUS.LOGIN_OK">
          {{ $t("mp:two_factor.login.title") }}
        </span>
        <span v-else> {{ $t("mp:two_factor.phone_confirm.title") }} </span>
      </p>

      <div class="has-text-grey mb-5">
        <span v-if="status === LOGIN_STATUS.LOGIN_OK">
          {{ $t("mp:two_factor.login.description") }}</span
        >
        <span v-else>
          {{ $t("mp:two_factor.phone_confirm.description") }}
        </span>
      </div>

      <validation-observer ref="observer">
        <BInputWithValidation
          :label="
            status === LOGIN_STATUS.LOGIN_OK
              ? $t('mp:two_factor.login.input.code.label')
              : $t('mp:two_factor.phone_confirm.input.code.label')
          "
          rules="required"
          label-position="on-border"
          input-id="one-time-code"
          autocomplete="one-time-code"
          inputmode="numeric"
          v-model="secondFactorCode"
        />

        <b-button
          type="is-blue"
          native-type="submit"
          :loading="loading"
          expanded
        >
          <span v-if="status === LOGIN_STATUS.LOGIN_OK">
            {{ $t("mp:two_factor.login.button.login") }}</span
          >
          <span v-else>
            {{ $t("mp:two_factor.phone_confirm.button.login") }}
          </span></b-button
        >
      </validation-observer>
    </template>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import { LOGIN_STATUS } from "../utils/const";

export default {
  name: "SecondFactor",
  title: "mp:page.second_factor.title",
  components: {
    BInputWithValidation: () =>
      import("@/components/input/BInputWithValidation.vue"),
  },
  data() {
    return {
      LOGIN_STATUS,
      secondFactorCode: "",
      secondFactorId: "",
      secondFactorNonce: "",
      status: "",
      successfulEmailConfirmation: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      secondFactor: "session/secondFactor",
      loggedIn: "session/isReady",
    }),
  },
  async mounted() {
    if (this.loggedIn) {
      await this.$router.push("/user/profile");
      return;
    }

    if (
      this.$route.query.id &&
      this.$route.query.code &&
      this.$route.query.nonce
    ) {
      // Email confirmation link
      this.secondFactorId = this.$route.query.id;
      this.secondFactorNonce = this.$route.query.nonce;
      this.secondFactorCode = this.$route.query.code;
      await this.confirmEmail();
    } else if (this.secondFactor) {
      // Second factor
      this.secondFactorId = this.secondFactor.id;
      this.secondFactorNonce = this.secondFactor.nonce;
      this.status = this.secondFactor.status;
      await this.$store.dispatch("session/deleteSecondFactor");
    } else {
      await this.$router.push("/login");
    }
  },
  methods: {
    async confirmEmail() {
      try {
        let confirmResponse = await this.$store.dispatch(
          "session/confirmEmail",
          {
            id: this.secondFactorId,
            nonce: this.secondFactorNonce,
            code: this.secondFactorCode,
          }
        );

        this.successfulEmailConfirmation = true;
        this.status = LOGIN_STATUS.PHONE_NOT_CONFIRMED;
        this.secondFactorId = confirmResponse.secondFactorId;
        this.secondFactorCode = null;
      } catch (e) {
        console.error(e);
        await this.$router.push("/login");
        //TODO: szép hibakezelés
      }
    },
    async doSubmit() {
      try {
        const valid = await this.$refs.observer.validate();
        if (!valid) return;
        this.loading = true;

        let solution = {
          id: this.secondFactorId,
          code: this.secondFactorCode,
          nonce: this.secondFactorNonce,
        };

        let loginResponse;
        if (this.status === LOGIN_STATUS.PHONE_NOT_CONFIRMED) {
          loginResponse = await this.$store.dispatch(
            "session/finishRegistration",
            solution
          );
        } else if (this.status === LOGIN_STATUS.LOGIN_OK) {
          loginResponse = await this.$store.dispatch(
            "session/finishLogin",
            solution
          );
        }

        let redirect = await this.$store.dispatch(
          "profile/setStatus",
          loginResponse
        );
        await this.$store.dispatch("i18n/fetchInternalTokensByLanguage", "hu");
        await this.$router.push(redirect);
      } catch (ex) {
        this.$buefy.toast.open({
          message: i18n.t("mp:login.error.general"),
          type: "is-danger",
        });
        console.error(ex);
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
